import { __awaiter } from "tslib";
import { computed, defineComponent, watch } from 'vue';
import { Link } from '@element-plus/icons-vue';
import { DataReferenceEnum } from '@/core/types/entities/hrgs/DataSourceEntities';
import { useStore } from 'vuex';
export default defineComponent({
    components: { Link },
    props: {
        modelValue: String,
        placeholder: [String, Number],
        disabled: Boolean,
        type: {
            type: String,
            default: 'text'
        },
        withRedirect: Boolean,
        dataReference: String
    },
    emits: ['update:modelValue', 'input'],
    setup(props, { emit }) {
        const value = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit('update:modelValue', value);
            }
        });
        const store = useStore();
        const redirectLink = () => {
            if (props.modelValue) {
                window.open(props.modelValue, '_blank');
            }
        };
        const employeeID = computed(() => {
            return store.getters.currentUser.employeeID;
        });
        watch([
            () => {
                return props.dataReference;
            },
            employeeID
        ], ([newVal, employeeID]) => __awaiter(this, void 0, void 0, function* () {
            if (!(newVal && employeeID))
                return;
            if (newVal === DataReferenceEnum.PersonalDataNation) {
                if (value.value === 'ID') {
                    emit('update:modelValue', 'Indonesia');
                }
            }
        }), {
            immediate: true
        });
        return { value, redirectLink };
    }
});
